module.exports = __webpack_public_path__ + "media/images/icons/icon-large-plus-031dd1779747020b386082e943029072.svg";